import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box, Column, Row } from '~/commonComponents';
import { IPostingPlanViewEntity } from '~/domain/PermanentJobs';
import { CheckSingleIcon } from '~/images/icons';
import { formatListingFee } from '~/components/PermanentJobsV2/utils';

interface IHiringPlanCardProps {
  plan?: IPostingPlanViewEntity;
}

export const HiringPlanCard = ({ plan }: IHiringPlanCardProps) => {
  const price = plan?.finalPrice ? formatListingFee(plan.finalPrice) : '-';

  return (
    <Box
      border={`1.5px solid ${colors.neutral[100]}`}
      borderRadius={8}
      backgroundColor={colors.shades[0]}
      paddingBlock={24}
      paddingInline={66}
      gap={16}
    >
      <Typography as="span" bold color={colors.neutral[600]} size="heading_3">
        Your Hiring Plan
      </Typography>

      <Column gap={14}>
        <Row gap={3}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span" color={colors.neutral[600]}>
              <Typography as="span" bold>Every applicant is pre-screened.</Typography> No sorting through unqualified
              resumes.
            </Typography>
          </Column>
        </Row>
        <Row gap={3}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span" color={colors.neutral[600]}>
              <Typography as="span" bold>No scheduling headaches.</Typography> Set your interview times, and professionals
              can apply directly to them.
            </Typography>
          </Column>
        </Row>
        <Row gap={3}>
          <CheckSingleIcon color={colors.secondary[500]} />
          <Column>
            <Typography as="span" color={colors.neutral[600]}>
              <Typography as="span" bold>Tap into GoTu&apos;s active network.</Typography> Reach candidates who
              aren&apos;t browsing job boards.
            </Typography>
          </Column>
        </Row>
      </Column>

      <Box
        paddingTop={22}
        paddingBottom={32}
        paddingHorizontal={25}
        borderRadius={10}
        backgroundColor={colors.shades[0]}
        boxShadow="0 2px 4px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.15)"
      >
        <Typography as="span" size="body_large" bold color={colors.neutral[600]}>
          Job Listing Fee
        </Typography>
        <Typography as="span" size="caption" color={colors.neutral[500]}>
          <Typography as="span" size="heading_2" bold color={colors.neutral[600]}>
            ${price}
          </Typography>{' '}
          /monthly
        </Typography>
        <Typography as="span" size="body_small" bold color={colors.primary[500]} style={{ marginTop: 10 }}>
          Your job will immediately become active and notify nearby candidates.
        </Typography>
      </Box>
    </Box>
  );
};
